const KEY = 'hadeva:wishlist:v1';

let sessionItems = [];
let persistenceAvailable = true;
const read = () => {
  if (!persistenceAvailable) return sessionItems;
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) || '[]');
    sessionItems = Array.isArray(stored)
      ? stored.filter((item) => item && typeof item === 'object' && item.id && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0, 50)
      : [];
  } catch (_) { persistenceAvailable = false; }
  return sessionItems;
};
const write = (items) => {
  sessionItems = items.slice(0, 50);
  try { localStorage.setItem(KEY, JSON.stringify(sessionItems)); } catch (_) { persistenceAvailable = false; }
  refresh(sessionItems);
};

function escapeHtml(value = '') {
  return String(value).replace(/[&<>'"]/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
}

function refresh(items = read()) {
  const ids = new Set(items.map((item) => String(item.id)));
  document.querySelectorAll('[data-hadeva-wishlist-toggle]').forEach((button) => {
    const saved = ids.has(String(button.dataset.productId));
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.classList.toggle('is-saved', saved);
    button.querySelector('[data-hadeva-heart]')?.replaceChildren(document.createTextNode(saved ? '♥' : '♡'));
  });
  document.querySelectorAll('[data-hadeva-wishlist-count]').forEach((node) => { node.textContent = String(items.length); });
  const list = document.querySelector('[data-hadeva-wishlist-list]');
  if (!list) return;
  if (!items.length) {
    list.innerHTML = '<p class="hadeva-wishlist__empty">Your saved edit is empty. Tap the heart on any product to keep it here.</p>';
    return;
  }
  list.innerHTML = items.map((item) => `
    <article class="hadeva-wishlist__item">
      <a href="${escapeHtml(item.url)}" class="hadeva-wishlist__item-link">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="" loading="lazy" width="120" height="150">` : ''}
        <span><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.price)}</small></span>
      </a>
      <button type="button" class="hadeva-wishlist__remove" data-hadeva-wishlist-remove="${escapeHtml(item.id)}" aria-label="Remove ${escapeHtml(item.title)} from saved items">Remove</button>
    </article>`).join('');
}

function openDrawer() {
  const dialog = document.querySelector('[data-hadeva-wishlist-dialog]');
  if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
  refresh();
}

function closeDrawer() {
  const dialog = document.querySelector('[data-hadeva-wishlist-dialog]');
  if (dialog instanceof HTMLDialogElement && dialog.open) dialog.close();
}

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-hadeva-wishlist-toggle]');
  if (toggle) {
    event.preventDefault();
    event.stopPropagation();
    const items = read();
    const id = String(toggle.dataset.productId || '');
    const existing = items.findIndex((item) => String(item.id) === id);
    if (existing >= 0) items.splice(existing, 1);
    else items.unshift({ id, title: toggle.dataset.productTitle || '', url: toggle.dataset.productUrl || '', image: toggle.dataset.productImage || '', price: toggle.dataset.productPrice || '' });
    write(items);
    return;
  }
  if (event.target.closest('[data-hadeva-wishlist-open]')) { event.preventDefault(); openDrawer(); return; }
  if (event.target.closest('[data-hadeva-wishlist-close]')) { closeDrawer(); return; }
  const remove = event.target.closest('[data-hadeva-wishlist-remove]');
  if (remove) write(read().filter((item) => String(item.id) !== String(remove.dataset.hadevaWishlistRemove)));
});

document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
document.addEventListener('shopify:section:load', () => refresh());
window.addEventListener('storage', (event) => { if (event.key === KEY || event.key === null) refresh(); });
refresh();
